import { Box } from '@mui/material';
// import cursor from '../assets/images/cursor-img.png';
import CameraFlashLoader from './CameraFlashLoader';

const Loader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      {/* <img src={cursor} className='loader-img' /> */}
      <CameraFlashLoader />
    </Box>
  );
};

export default Loader;
